"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const input_1 = __importDefault(require("@kyruus/input"));
const Search_1 = __importDefault(require("@kyruus/react-ikons/Search"));
const Cancel_1 = __importDefault(require("@kyruus/react-ikons/Cancel"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const SearchInput = ({ value, showClearIcon = false, onChange, onClearIconClick, intl }) => {
    const inputLabel = intl.formatMessage(messages_1.default.reviewsSearchInputPlaceholder);
    return (react_1.default.createElement(styles_1.SearchInputContainer, null,
        react_1.default.createElement(input_1.default, { "aria-label": inputLabel, hideLabel: true, label: inputLabel, name: "provider-reviews-search-input", id: "provider-profile-reviews-search-input", value: value, onChange: onChange, "data-testid": "search-input" }),
        value.length === 0 && (react_1.default.createElement(styles_1.SearchIconWrapper, { className: "reviews-search-icon-container", "aria-hidden": "true" },
            react_1.default.createElement(Search_1.default, { className: "reviews-search-icon" }))),
        value.length > 0 && showClearIcon && onClearIconClick && (react_1.default.createElement(styles_1.CancelButton, { onClick: onClearIconClick, "aria-label": intl.formatMessage(messages_1.default.reviewsSearchInputClearButton) },
            react_1.default.createElement(Cancel_1.default, null)))));
};
exports.default = (0, intl_1.injectIntl)(SearchInput);
//# sourceMappingURL=search-input.js.map